import React from "react";
import { Box, Typography } from "@mui/material";

export default function AIBadge({ show, size = "small" }) {
  const isAI = show === true || show === "true" || show === 1 || show === "1";
  if (!isAI) return null;
  const dim = size === "large" ? 20 : 16;
  const fontSize = size === "large" ? 8 : 7;

  return (
    <Box
      className="ai-badge"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: dim,
        height: dim,
        borderRadius: "50%",
        border: "1px solid rgba(255, 255, 255, 0.5)",
        backgroundColor: "rgba(255, 255, 255, 0.12)",
        color: "#fff",
        lineHeight: 1,
        flexShrink: 0,
      }}
    >
      <Typography
        sx={{
          fontSize,
          fontWeight: 800,
          letterSpacing: 0.5,
          color: "inherit",
          lineHeight: 1,
        }}
      >
        AI
      </Typography>
    </Box>
  );
}
